export enum document_status {
  DELETED = "DELETED",
  NOT_UPLOADED = "NOT_UPLOADED",
  UPLOADED = "UPLOADED",
  REQUESTED = "REQUESTED",
  DECLINED = "DECLINED",
  VALIDATED = "VALIDATED",
}

export enum DocumentType {
  ARTICLE_OF_ASSOCIATION = "ARTICLE_OF_ASSOCIATION",
  BANK_ACCOUNT_STATEMENT = "BANK_ACCOUNT_STATEMENT",
  COMPANY_INCORPORATION = "COMPANY_INCORPORATION",
  DRIVING_LICENCE = "DRIVING_LICENCE",
  HEALTH_INSURANCE = "HEALTH_INSURANCE",
  IDENTITY_CARD = "IDENTITY_CARD",
  INVOICE = "INVOICE",
  KYC_SUMMARY = "KYC_SUMMARY",
  PASSPORT = "PASSPORT",
  POWER_OF_ATTORNEY = "POWER_OF_ATTORNEY",
  PROOF_OF_ADDRESS = "PROOF_OF_ADDRESS",
  RESIDENCE_PERMIT = "RESIDENCE_PERMIT",
  RESUME = "RESUME",
  RISK_ASSESSMENT = "RISK_ASSESSMENT",
  SOURCE_OF_FUNDS = "SOURCE_OF_FUNDS",
  TAX_STATEMENT = "TAX_STATEMENT",
  VISA = "VISA",
  UBO_REGISTRY = "UBO_REGISTRY",
  COMPANY_REGISTRY_EXTRACT = "COMPANY_REGISTRY_EXTRACT",
  PAYSLIP = "PAYSLIP",
  BANK_ACCOUNT_DETAILS = "BANK_ACCOUNT_DETAILS",
  SOURCE_OF_WEALTH_DECLARATION = "SOURCE_OF_WEALTH_DECLARATION",
  OTHER = "OTHER",
  TRANSACTION_RECEIPT = "TRANSACTION_RECEIPT",
  DILIGENCE_REVIEW = "DILIGENCE_REVIEW",
  DIRECT_DEBIT_MANDATE = "DIRECT_DEBIT_MANDATE",
  FAMILY_RECORD_BOOK = "FAMILY_RECORD_BOOK",
  SELFIE = "SELFIE",
}
